export default __webpack_public_path__ + "assets/images/bonus.9dc610.png";